import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../../../../services/rest/rest.service';
import { Agreement } from './agreement.domain';

@Injectable()
export class ConsolidatedAgreementsRestService {
  private readonly restService = inject(RestService);

  saveAgreements(agreementsInfo: Array<Agreement>): Observable<void> {
    return this.restService.getResource('agreements_v2.update').put(agreementsInfo);
  }
}

